import $ from 'jquery';

class Topics {
    constructor(el) {
        this.el = el;
        this.anchorsEl = el.find('.topics__anchors');
        this.anchorsEl.on('click', 'a[href^="#"]', function(e) {
            const hash = $(this).attr('href');
            if($(hash).length) {
                e.preventDefault();
                $([document.documentElement, document.body]).animate({
                    scrollTop: $(hash).offset().top - $('.top').height()
                }, 750);
            }
        });
    }
}

export default Topics;